/* unplugin-vue-components disabled */import { render } from "./MockExamQuestionRenderPage.vue?vue&type=template&id=37a462d2&scoped=true"
import script from "./MockExamQuestionRenderPage.vue?vue&type=script&lang=js"
export * from "./MockExamQuestionRenderPage.vue?vue&type=script&lang=js"

import "./MockExamQuestionRenderPage.vue?vue&type=style&index=0&id=37a462d2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37a462d2"]])

export default __exports__